//这里是 员工管理 模块的路由文件

const basePath = "/admin/staff/";
export default [
    //员工审核
    {
        path: `${basePath}trial`,
        name: 'StaffTrial',
        component: r => require.ensure([], () => r(require('@/views/staff/StaffTrial')), 'Staff')
    },
    //审核详情
    {
        path: `${basePath}description`,
        name: 'StaffDescription',
        component: r => require.ensure([], () => r(require('@/views/staff/StaffDescription')), 'Staff')
    },
    //工程师列表
    {
        path: `${basePath}engineer`,
        name: 'StaffEngineer',
        component: r => require.ensure([], () => r(require('@/views/staff/StaffEngineer')), 'Staff')
    },
    //员工详情
    {
        path: `${basePath}list/des`,
        name: 'StaffListDescription',
        component: r => require.ensure([], () => r(require('@/views/staff/StaffListDescription')), 'Staff')
    }
]
